module.exports = __webpack_public_path__ + "img/10th_financial-wellness.2762b252.webp";